import { STATSIG_EXPERIMENTS } from '@src/config/statsig-experiments.config'
import { useStatsigExperimentBucket } from '@src/experiments/statsig-integration'
import { getIsGoldBarProduct } from '@src/quince-components/src/atoms/productCTA/utils'
import Product from '@src/quince-site-common/src/domains/Product'
import Bundle, { PRODUCT_TYPES } from '@src/quince-site-common/src/domains/Product/BundleProduct'

import { isInNewCartExperiment } from '../new-cart-exp-helper'

export const useBuyNowPDP = (product: Product | Bundle) => {
  const buyNowPdpExperimentBucket = useStatsigExperimentBucket(STATSIG_EXPERIMENTS.BUY_NOW_BUTTON_PDP)
  const isBuyNowExpShowBucket = buyNowPdpExperimentBucket === 'Show'
  const isGoldBarProduct = product.type === PRODUCT_TYPES.BUNDLE ? false : getIsGoldBarProduct(product)
  const showBuyNowButton = isInNewCartExperiment() && isBuyNowExpShowBucket && !isGoldBarProduct
  return showBuyNowButton
}
